import React from "react";

const fontFamilies = [
  "Arial",
  "Georgia",
  "Times New Roman",
  "Verdana",
  "Tahoma",
  "Roboto",
  "Helvetica",
];

export default function LinkBlockEditor({ block, index, setFieldValue }) {
  const handleStyleChange = (key, value) => {
    setFieldValue(`blocks[${index}].styles.${key}`, value);
  };

  const LabeledInput = ({ label, children }) => (
    <div className='flex flex-col space-y-1'>
      <label className='text-sm font-semibold text-black dark:text-gray-300'>
        {label}
      </label>
      {children}
    </div>
  );

  return (
    <div className='space-y-3 mt-2'>
      {/* Link URL */}
      <div>
        <label className='text-sm font-medium'>Link URL</label>
        <input
          type='text'
          name={`blocks[${index}].value`}
          placeholder='https://example.com'
          defaultValue={block.value}
          onBlur={(e) =>
            setFieldValue(`blocks[${index}].value`, e.target.value)
          }
          className='w-full mt-1 border px-2 py-1 rounded  bg-white dark:bg-gray-800'
        />
        {/* {block.value &&
          !/^https?:\/\/[^\s$.?#].[^\s]*$/gm.test(block.value) && (
            <p className='text-red-600 text-sm mt-1'>
              ⚠️ Please enter a valid URL
            </p>
          )} */}
      </div>

      {/* Link Text */}
      <div>
        <label className='text-sm font-medium'>Link Text</label>
        <input
          type='text'
          placeholder='Link Text (e.g. Visit Site)'
          defaultValue={block.text || ""}
          onBlur={(e) => setFieldValue(`blocks[${index}].text`, e.target.value)}
          className='w-full border  bg-white dark:bg-gray-800 px-2 py-1 rounded'
        />
      </div>

      {/* Style Inputs */}
      <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2 text-sm mt-5'>
        <LabeledInput label='Font Size'>
          <input
            type='text'
            placeholder='e.g. 16px'
            defaultValue={block.styles?.fontSize || ""}
            onBlur={(e) => handleStyleChange("fontSize", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>

        <LabeledInput label='Font Weight'>
          <select
            value={block.styles?.fontWeight || ""}
            onChange={(e) => handleStyleChange("fontWeight", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          >
            <option value=''>Select Weight</option>
            <option value='normal'>Normal</option>
            <option value='bold'>Bold</option>
            <option value='lighter'>Lighter</option>
            <option value='bolder'>Bolder</option>
            {[100, 200, 300, 400, 500, 600, 700, 800, 900].map((val) => (
              <option key={val} value={val}>
                {val}
              </option>
            ))}
          </select>
        </LabeledInput>

        <LabeledInput label='Font Family'>
          <select
            value={block.styles?.fontFamily || ""}
            onChange={(e) => handleStyleChange("fontFamily", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          >
            <option value=''>Select Font</option>
            {fontFamilies.map((font) => (
              <option key={font} value={font}>
                {font}
              </option>
            ))}
          </select>
        </LabeledInput>

        <LabeledInput label='Text Color'>
          <input
            type='color'
            defaultValue={block.styles?.color || "#000"}
            onBlur={(e) => handleStyleChange("color", e.target.value)}
            className='w-full h-8 bg-white dark:bg-gray-800 cursor-pointer rounded border border-gray-300'
          />
        </LabeledInput>

        <LabeledInput label='Background Color'>
          <input
            type='color'
            defaultValue={block.styles?.backgroundColor || "#ffffff"}
            onBlur={(e) => handleStyleChange("backgroundColor", e.target.value)}
            className='w-full h-8 bg-white dark:bg-gray-800 cursor-pointer rounded border border-gray-300'
          />
        </LabeledInput>

        <LabeledInput label='Text Align'>
          <select
            value={block.styles?.textAlign || ""}
            onChange={(e) => handleStyleChange("textAlign", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          >
            <option value=''>Select Alignment</option>
            <option value='left'>Left</option>
            <option value='center'>Center</option>
            <option value='right'>Right</option>
            <option value='justify'>Justify</option>
          </select>
        </LabeledInput>

        <LabeledInput label='Text Decoration'>
          <select
            value={block.styles?.textDecoration || ""}
            onChange={(e) =>
              handleStyleChange("textDecoration", e.target.value)
            }
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          >
            <option value=''>Select Decoration</option>
            <option value='none'>None</option>
            <option value='underline'>Underline</option>
            <option value='line-through'>Line Through</option>
          </select>
        </LabeledInput>

        <LabeledInput label='Text Transform'>
          <select
            value={block.styles?.textTransform || ""}
            onChange={(e) => handleStyleChange("textTransform", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          >
            <option value=''>Select Transform</option>
            <option value='none'>None</option>
            <option value='uppercase'>UPPERCASE</option>
            <option value='lowercase'>lowercase</option>
            <option value='capitalize'>Capitalize</option>
          </select>
        </LabeledInput>

        <LabeledInput label='Line Height'>
          <input
            type='text'
            placeholder='e.g. 1.5'
            defaultValue={block.styles?.lineHeight || ""}
            onBlur={(e) => handleStyleChange("lineHeight", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>

        <LabeledInput label='Letter Spacing'>
          <input
            type='text'
            placeholder='e.g. 1px'
            defaultValue={block.styles?.letterSpacing || ""}
            onBlur={(e) => handleStyleChange("letterSpacing", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>

        <LabeledInput label='Padding'>
          <input
            type='text'
            placeholder='e.g. 10px'
            defaultValue={block.styles?.padding || ""}
            onBlur={(e) => handleStyleChange("padding", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>

        <LabeledInput label='Margin'>
          <input
            type='text'
            placeholder='e.g. 10px'
            defaultValue={block.styles?.margin || ""}
            onBlur={(e) => handleStyleChange("margin", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>

        <LabeledInput label='Border Radius'>
          <input
            type='text'
            placeholder='e.g. 4px or 50%'
            defaultValue={block.styles?.borderRadius || ""}
            onBlur={(e) => handleStyleChange("borderRadius", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>
        <LabeledInput label='Display'>
          <select
            value={block.styles?.display || ""}
            onChange={(e) => handleStyleChange("display", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-green-500'
          >
            <option value=''>Select Display</option>
            <option value='inline'>inline</option>
            <option value='block'>block</option>
            <option value='inline-block'>inline-block</option>
            <option value='flex'>flex</option>
            <option value='inline-flex'>inline-flex</option>
            <option value='none'>none</option>
          </select>
        </LabeledInput>
        <LabeledInput label='Width'>
          <input
            type='text'
            placeholder='e.g. 100px or 100%'
            defaultValue={block.styles?.width || ""}
            onBlur={(e) => handleStyleChange("width", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>

        <LabeledInput label='Height'>
          <input
            type='text'
            placeholder='e.g. 50px or auto'
            defaultValue={block.styles?.height || ""}
            onBlur={(e) => handleStyleChange("height", e.target.value)}
            className='border bg-white dark:bg-gray-800 rounded px-2 py-1'
          />
        </LabeledInput>
      </div>
    </div>
  );
}
